import { generateOverviewPdf } from "@/lib/overviewPdf";
import { Download } from "lucide-react";
import { toast } from "sonner";

export default function Footer() {
  const onDownload = () => {
    try {
      generateOverviewPdf();
      toast.success("Overview PDF downloaded.");
    } catch (e) {
      console.error(e);
      toast.error("Could not generate overview.");
    }
  };
  return (
    <footer
      className="relative border-t border-[var(--line)] bg-ink"
      data-testid="footer"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-10 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3">
              <span className="h-9 w-9 border border-gold/60 grid place-items-center">
                <span className="font-display text-gold text-2xl leading-none">A</span>
              </span>
              <div className="leading-tight">
                <div className="font-display text-xl text-ivory">Advik Ventures</div>
                <div className="text-[10px] tracking-eyebrow uppercase text-ivory-dim">
                  Capability, Engineered.
                </div>
              </div>
            </div>
            <p className="mt-6 max-w-sm text-ivory/60 leading-relaxed">
              A specialist capability partner for family offices, private
              offices, and conglomerates. Architecting, staffing, and operating
              capability centers as an extension of the principal&rsquo;s office.
            </p>
          </div>

          <div className="md:col-span-2">
            <div className="text-[10px] tracking-eyebrow uppercase text-gold mb-4">
              Explore
            </div>
            <ul className="space-y-2 text-ivory/70 text-sm">
              <li>
                <a href="#approach" className="gold-underline">Manifesto</a>
              </li>
              <li>
                <a href="#framework" className="gold-underline">Framework</a>
              </li>
              <li>
                <a href="#modules" className="gold-underline">Modules</a>
              </li>
              <li>
                <a href="#regions" className="gold-underline">Regions</a>
              </li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <div className="text-[10px] tracking-eyebrow uppercase text-gold mb-4">
              Hubs
            </div>
            <ul className="space-y-2 text-ivory/70 text-sm">
              <li>UAE · Abu Dhabi · Dubai</li>
              <li>Singapore · Marina Bay</li>
              <li>India · Mumbai · GIFT City</li>
            </ul>
            <div className="text-[10px] tracking-eyebrow uppercase text-gold mt-6 mb-3">
              Frameworks
            </div>
            <ul className="space-y-1.5 text-ivory/60 text-xs">
              <li>ADGM (FSRA) · VARA</li>
              <li>MAS · PSA</li>
              <li>IFSCA · GIFT City</li>
              <li>MiCA · CASP · SFDR</li>
              <li>GENIUS · FINTRAC</li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <div className="text-[10px] tracking-eyebrow uppercase text-gold mb-4">
              Contact
            </div>
            <a
              href="mailto:avadh@advikvc.com"
              data-testid="footer-email"
              className="font-display text-2xl text-ivory gold-underline"
            >
              avadh@advikvc.com
            </a>
            <div className="mt-6 flex flex-col gap-2">
              <a
                href="#workshop"
                data-testid="footer-cta"
                className="inline-flex items-center gap-2 px-4 py-2 text-xs tracking-eyebrow uppercase border border-gold/60 text-gold hover:bg-gold hover:text-ink transition-colors w-fit"
              >
                Schedule Workshop →
              </a>
              <button
                type="button"
                onClick={onDownload}
                data-testid="footer-download-overview"
                className="inline-flex items-center gap-2 px-4 py-2 text-xs tracking-eyebrow uppercase text-ivory/80 hover:text-gold transition-colors w-fit"
              >
                <Download size={12} strokeWidth={1.5} />
                Download Overview PDF
              </button>
            </div>
          </div>
        </div>

        <div className="mt-16 md:mt-20 pt-6 border-t border-[var(--line)] flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <div className="text-[10px] tracking-eyebrow uppercase text-ivory-dim">
            © {new Date().getFullYear()} Advik Ventures. All rights reserved.
          </div>
          <div className="text-[10px] tracking-eyebrow uppercase text-ivory-dim">
            Confidential · By invitation
          </div>
        </div>
      </div>

      {/* Colossal wordmark */}
      <div className="overflow-hidden border-t border-[var(--line)]">
        <div className="mx-auto max-w-[1400px] px-6 md:px-10 py-8 md:py-10 flex items-center justify-center">
          <div className="font-display text-[16vw] md:text-[13vw] leading-none tracking-tight text-ivory/[0.06] select-none">
            ADVIK
          </div>
        </div>
      </div>
    </footer>
  );
}
